import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import {
  fetchMorePlanListAsync,
  fetchPlanListAsync,
  fetchPlanListFilterAsync,
  updatePendingFilters,
} from 'store/planList/actions';

import type { PlanList, PlanListErrors } from 'PlanList-Types';

export const isFetching = createReducer(false as boolean)
  .handleAction([fetchPlanListAsync.request], () => true)
  .handleAction([fetchPlanListAsync.success, fetchPlanListAsync.failure], () => false);

export const isFetchingMorePlans = createReducer(false as boolean)
  .handleAction([fetchMorePlanListAsync.request], () => true)
  .handleAction([fetchMorePlanListAsync.success, fetchMorePlanListAsync.failure], () => false);

export const planList = createReducer({} as PlanList)
  .handleAction(fetchPlanListAsync.success, (_state, action) => action.payload)
  .handleAction(fetchPlanListAsync.failure, () => ({}) as PlanList)
  .handleAction(fetchMorePlanListAsync.success, (state, action) => ({
    ...state,
    offset: action.payload.offset,
    limit: action.payload.limit,
    plans: state.plans.concat(action.payload.plans),
  }));

export const errors = createReducer([] as PlanListErrors[])
  .handleAction(
    [fetchPlanListAsync.failure, fetchMorePlanListAsync.failure],
    (_state, action) => action.payload,
  )
  .handleAction(
    [fetchPlanListAsync.request, fetchMorePlanListAsync.request],
    () => [] as PlanListErrors[],
  );

// only being used as pending filters while filter selection
export const isFetchingFilters = createReducer(false)
  .handleAction(fetchPlanListFilterAsync.request, () => true)
  .handleAction([fetchPlanListFilterAsync.success, fetchPlanListFilterAsync.failure], () => false);

export const prefetchedPlanList = createReducer({} as PlanList)
  .handleAction(
    [updatePendingFilters, fetchPlanListFilterAsync.success, fetchPlanListAsync.success],
    (_state, action) => action.payload,
  )
  .handleAction(fetchPlanListFilterAsync.failure, () => ({}) as PlanList);

const planListReducer = combineReducers({
  isFetching,
  isFetchingFilters,
  isFetchingMorePlans,
  planList,
  prefetchedPlanList,
  errors,
});

export default planListReducer;
export type PlanListState = ReturnType<typeof planListReducer>;
